"use client";

import { ConvexProvider, ConvexReactClient } from "convex/react";
import { ReactNode } from "react";

// const convex = new ConvexReactClient(process.env.NEXT_PUBLIC_CONVEX_URL!);
// Create two clients
const frontendClient = new ConvexReactClient(
  process.env.NEXT_PUBLIC_CONVEX_FRONTEND_URL!
);
// const backendClient = new ConvexReactClient(
//   process.env.NEXT_PUBLIC_CONVEX_BACKEND_URL!
// );
export function ConvexClientProvider({ children }: { children: ReactNode }) {
  return (
    <ConvexProvider client={frontendClient}>
      {children}
    </ConvexProvider>
  );
}
